<template>
  <b-card>
    <b-card-text>
      <h3>{{ congress.title }}</h3>
      <div
        class="mt-2"
        v-html="congress.description"
      />
    </b-card-text>
    <template #footer>
      <b-button
        :to="{ name: ctaRoute, params: { id: congress.id } }"
        variant="primary"
      >
        {{ $t(ctaLabel) }}
      </b-button>
    </template>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  components: { BCard },
  props: {
    congress: {
      type: Object,
      required: true,
    },
    ctaRoute: {
      type: String,
      default: 'congress-participation',
    },
    ctaLabel: {
      type: String,
      default: 'My Participation',
    },
  },
}
</script>
